import { render, staticRenderFns } from "./InvestorFeeConfiguration.vue?vue&type=template&id=2b224f46&scoped=true"
import script from "./InvestorFeeConfiguration.vue?vue&type=script&lang=js"
export * from "./InvestorFeeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./InvestorFeeConfiguration.vue?vue&type=style&index=0&id=2b224f46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b224f46",
  null
  
)

export default component.exports